import packageJson from '../../package.json';

export class SycaiService {
  public static readonly REGISTRATION = {
    name: 'sycaiService',
    create: () => new SycaiService(),
  };

  public getBanner(): string {
    return `[sycai] ${packageJson.name} ${packageJson.version} registered`;
  }
}
